//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep } from "lodash-es";
import { mapGetters, mapMutations } from "vuex";

import TransitionShuffle from '../../global/transitions/Shuffle.vue'
import AppResult from './Result.vue';
import AppLrlResult from './LegalResearchLibrary/Result.vue';
import AppResultMinimal from './ListMinimal/ResultMinimal.vue';
import AppCalendar from './Calendar/Calendar';
export default {
	name: "AppResults",
	props: {
		results: Array
	},
	components: {
		TransitionShuffle,
		AppResult,
		AppResultMinimal,
		AppCalendar,
		AppLrlResult,
	},
	data() {
		return {
			viewIsChanging: false
		};
	},
	computed: {
		...mapGetters(["resultView", "aboveMdBreakpoint", "reloading"]),
		columnCount() {
			if (!this.config.gridColumnCount || isNaN(parseInt(this.config.gridColumnCount))) return 3;
			else return parseInt(this.config.gridColumnCount);
		},
		resultsClasses() {
			return {
				'increase-row-gap': this.config.showResultType && (!this.config.showResultImage || this.resultView == 'list'),
				'app-results--list-view': this.resultView == 'list',
				'app-results--list-minimal': this.resultView == 'list-minimal',
				'app-results--no-images': (!this.config.showResultImage || this.resultView == 'list') && this.config.showResultType,
				'app-results--calendar': this.resultView == 'calendar',
				'app-results--view-change': this.viewIsChanging,
			}
		},
		calendarToggleText() {
			if (this.resultView == 'calendar') return 'Switch to List View';
			else return 'Switch to Calendar View';
		},
		noResultsMarkup() {
			if (!!this.config.noResultsText) return this.config.noResultsText;
			else return `<h3>Sorry, there were no results found for your search. Please try again.</h3>`;
		}
	},
	methods: {
		...mapMutations(["setStateValue", "extend"]),
		toggleCalendarView() {
			this.viewIsChanging = true;
			let newPageSize;
			if (this.resultView == 'calendar') {
				newPageSize = 12;
				this.setStateValue(['resultView', 'grid']);
			}	else {
				newPageSize = 100;
				this.setStateValue(['resultView', 'calendar']);
			}
			this.extend(extended => {
				let obj = cloneDeep(extended);
				obj.pageSizeOverride = newPageSize;
				return obj;
			});
			setTimeout(() => {
				this.viewIsChanging = false;
			}, 250);
		},
    getElTop() {
      let elem = this.$root.$el;
      let distance = 0;
			if (!!elem.closest(".semi-sticky-header")) {
				const header = document.querySelector("header.header");
				distance -= header.getBoundingClientRect().height;
			}
      do {
        distance += elem.offsetTop;
        elem = elem.offsetParent;
      } while (elem);
      distance = distance < 0 ? 0 : distance;
      return distance;
    },
    scrollToTop() {
      if (this.config.scrollOnReload) window.scrollTo({ top: this.getElTop(), behavior: "smooth" });
    },
	},
  watch: {
    reloading() {
      if (this.resultView != "calendar" || !this.aboveMdBreakpoint) this.scrollToTop();
    },
  },
	created() {},
	mounted() {},
};
